export const WRITING_TASKS_DATA = {
    'mad-libs-adventure': {
        instructions: `Fill in the blanks to create a story!`,
        wordCount: 0,
        madLibsTemplates: [
            {
                id: 'adventure',
                title: 'Magical Adventure',
                image: '/images/mad-libs/magical.png',
                imageAlt: 'Magical crystal ball',
                story: `Once upon a time, there was a [adjective1] [noun1] named [name]. They lived in a [adjective2] [place] and loved to [verb1] every day. One morning, they woke up to find a [adjective3] [animal] sitting on their [noun2]. "Oh my [exclamation]!" they said. "This is the most [adjective4] day ever!" The [animal] looked at them with [adjective5] eyes and said, "I need your help to find the [adjective6] [treasure]!" So [name] grabbed their [noun3] and together they [verb2] through the [adjective7] [place] until they found the [treasure]. It was [adjective8] and [color]! "This is amazing!" said [name]. "I never thought I'd find something so [adjective8]!" And they all lived [adverb] ever after.`,
                blanks: [
                    { id: 'adjective1', label: 'Adjective', placeholder: 'silly, brave' },
                    { id: 'noun1', label: 'Noun', placeholder: 'wizard, robot' },
                    { id: 'name', label: 'Name', placeholder: 'Alex, Luna' },
                    { id: 'adjective2', label: 'Adjective', placeholder: 'magical, spooky' },
                    { id: 'place', label: 'Place', placeholder: 'castle, forest' },
                    { id: 'verb1', label: 'Verb (Base Form)', placeholder: 'dance, sing (to ...)' },
                    { id: 'adjective3', label: 'Adjective', placeholder: 'giant, purple' },
                    { id: 'animal', label: 'Animal', placeholder: 'elephant, unicorn' },
                    { id: 'noun2', label: 'Noun', placeholder: 'bed, table' },
                    { id: 'exclamation', label: 'Exclamation', placeholder: 'goodness, wow' },
                    { id: 'adjective4', label: 'Adjective', placeholder: 'wonderful, terrible' },
                    { id: 'adjective5', label: 'Adjective', placeholder: 'sad, happy' },
                    { id: 'adjective6', label: 'Adjective', placeholder: 'dark, bright' },
                    { id: 'treasure', label: 'Treasure', placeholder: 'gold, magic wand' },
                    { id: 'noun3', label: 'Noun', placeholder: 'sword, backpack' },
                    { id: 'verb2', label: 'Verb (Past Tense)', placeholder: 'ran, flew, swam' },
                    { id: 'adjective7', label: 'Adjective', placeholder: 'shiny, huge' },
                    { id: 'adjective8', label: 'Adjective', placeholder: 'incredible, strange' },
                    { id: 'color', label: 'Color', placeholder: 'blue, silver' },
                    { id: 'adverb', label: 'Adverb', placeholder: 'happily, magically' }
                ]
            },
            {
                id: 'space',
                title: 'Space Exploration',
                image: '/images/mad-libs/space.png',
                imageAlt: 'Space scene',
                story: `Captain [name] was the [adjective1] pilot of the spaceship [noun1]. They were on a mission to explore the [adjective2] planet [place] when suddenly, a [adjective3] [animal] appeared on their [noun2]! "What the [exclamation]!" shouted the captain. "This is the most [adjective4] thing I've ever seen!" The [animal] spoke in a [adjective5] voice: "I need your help to save my [adjective6] [treasure]!" So Captain [name] grabbed their [noun3] and together they [verb1] through the [adjective7] [place] until they found the [treasure]. It was [adjective8] and [color]! "Incredible!" said Captain [name]. "I never thought I'd discover something so [adjective9]!" And they all lived [adverb] ever after.`,
                blanks: [
                    { id: 'name', label: 'Name', placeholder: 'Alex, Luna' },
                    { id: 'adjective1', label: 'Adjective', placeholder: 'brave, skilled' },
                    { id: 'noun1', label: 'Spaceship Name', placeholder: 'Starfire, Galaxy' },
                    { id: 'adjective2', label: 'Adjective', placeholder: 'mysterious, dangerous' },
                    { id: 'place', label: 'Planet Name', placeholder: 'Zephyr, Nova' },
                    { id: 'adjective3', label: 'Adjective', placeholder: 'giant, glowing' },
                    { id: 'animal', label: 'Alien Creature', placeholder: 'Zorg, Blip' },
                    { id: 'noun2', label: 'Noun', placeholder: 'control panel, chair' },
                    { id: 'exclamation', label: 'Exclamation', placeholder: 'stars, wow' },
                    { id: 'adjective4', label: 'Adjective', placeholder: 'incredible, strange' },
                    { id: 'adjective5', label: 'Adjective', placeholder: 'deep, robotic' },
                    { id: 'adjective6', label: 'Adjective', placeholder: 'precious, ancient' },
                    { id: 'treasure', label: 'Treasure', placeholder: 'crystal, artifact' },
                    { id: 'noun3', label: 'Noun', placeholder: 'laser gun, helmet' },
                    { id: 'verb1', label: 'Verb (Past Tense)', placeholder: 'flew, raced' },
                    { id: 'adjective7', label: 'Adjective', placeholder: 'dark, bright' },
                    { id: 'adjective8', label: 'Adjective', placeholder: 'glowing, massive' },
                    { id: 'color', label: 'Color', placeholder: 'silver, neon' },
                    { id: 'adjective9', label: 'Adjective', placeholder: 'amazing, fantastic' },
                    { id: 'adverb', label: 'Adverb', placeholder: 'peacefully, excitedly' }
                ]
            },
            {
                id: 'detective',
                title: 'Mystery Detective',
                image: '/images/mad-libs/mystery.png',
                imageAlt: 'Detective scene',
                story: `Detective [name] was the [adjective1] investigator in [place]. One [adjective2] morning, they received a call about a [adjective3] [animal] that had stolen a [noun1]. "Oh [exclamation]!" they exclaimed. "This is the most [adjective4] case I've ever seen!" The [animal] had left a [adjective5] clue: a [noun2] with [color1] markings. Detective [name] grabbed their [noun3] and [verb1] to the [adjective6] [place2] where they found the [animal] guarding the [treasure]. "I need your help!" said the [animal] in a [adjective7] voice. "Someone stole my [adjective8] [treasure]!" Together, they [verb2] through the [adjective9] [place3] until they found the real thief. It was [adjective10] and [color2]! "Case closed!" said Detective [name]. "I never thought I'd solve something so [adjective11]!" And they all lived [adverb] ever after.`,
                blanks: [
                    { id: 'name', label: 'Name', placeholder: 'Sherlock, Watson' },
                    { id: 'adjective1', label: 'Adjective', placeholder: 'brilliant, clever' },
                    { id: 'place', label: 'City', placeholder: 'London, Paris' },
                    { id: 'adjective2', label: 'Adjective', placeholder: 'foggy, sunny' },
                    { id: 'adjective3', label: 'Adjective', placeholder: 'sneaky, clever' },
                    { id: 'animal', label: 'Animal', placeholder: 'cat, dog' },
                    { id: 'noun1', label: 'Stolen Item', placeholder: 'diamond, cookie' },
                    { id: 'exclamation', label: 'Exclamation', placeholder: 'my goodness, wow' },
                    { id: 'adjective4', label: 'Adjective', placeholder: 'puzzling, strange' },
                    { id: 'adjective5', label: 'Adjective', placeholder: 'mysterious, unusual' },
                    { id: 'noun2', label: 'Clue', placeholder: 'footprint, note' },
                    { id: 'color1', label: 'Color', placeholder: 'red, blue' },
                    { id: 'noun3', label: 'Detective Tool', placeholder: 'magnifying glass' },
                    { id: 'verb1', label: 'Verb (Past Tense)', placeholder: 'rushed, ran' },
                    { id: 'adjective6', label: 'Adjective', placeholder: 'dark, spooky' },
                    { id: 'place2', label: 'Location', placeholder: 'alley, park' },
                    { id: 'treasure', label: 'Treasure', placeholder: 'chest, box' },
                    { id: 'adjective7', label: 'Adjective', placeholder: 'worried, sad' },
                    { id: 'adjective8', label: 'Adjective', placeholder: 'precious, valuable' },
                    { id: 'verb2', label: 'Verb (Past Tense)', placeholder: 'searched, explored' },
                    { id: 'adjective9', label: 'Adjective', placeholder: 'hidden, secret' },
                    { id: 'place3', label: 'Place', placeholder: 'basement, attic' },
                    { id: 'adjective10', label: 'Adjective', placeholder: 'surprising, shocking' },
                    { id: 'color2', label: 'Color', placeholder: 'gold, silver' },
                    { id: 'adjective11', label: 'Adjective', placeholder: 'incredible, fantastic' },
                    { id: 'adverb', label: 'Adverb', placeholder: 'happily, peacefully' }
                ]
            },
            {
                id: 'seafaring',
                title: 'Seafaring Voyages',
                image: '/images/mad-libs/seafaring.png',
                imageAlt: 'A sailing ship on the ocean',
                story: `Captain [name] stood at the bow of the [adjective1] ship [noun1], gazing at the [adjective2] sea. They were searching for the legendary [treasure] hidden on the island of [place]. "[exclamation]!" shouted the [adjective3] first mate. "A [adjective4] [animal] is following our ship!" Captain [name] grabbed their [noun2] and [verb1] to the deck. The creature looked [adjective5] but [adjective6]. Suddenly, a [adjective7] storm rolled in from the [direction], turning the waves [color1] and [color2]. "We must [verb2] before the storm hits!" cried the captain. The crew [verb3] [adverb1] through the [adjective8] waters until they spotted the island. It was [adjective9] and covered in [adjective10] [noun3]. "[exclamation2]!" gasped Captain [name]. "We finally found the [treasure]!" The crew cheered [adverb2] as they [verb4] ashore.`,
                blanks: [
                    { id: 'name', label: 'Name', placeholder: 'Morgan, Drake' },
                    { id: 'adjective1', label: 'Adjective', placeholder: 'mighty, creaky' },
                    { id: 'noun1', label: 'Ship Name', placeholder: 'Tempest, Horizon' },
                    { id: 'adjective2', label: 'Adjective', placeholder: 'stormy, endless' },
                    { id: 'treasure', label: 'Treasure', placeholder: 'golden compass, pearl' },
                    { id: 'place', label: 'Island Name', placeholder: 'Skull Rock, Emerald Isle' },
                    { id: 'exclamation', label: 'Exclamation', placeholder: 'Blimey, Ahoy' },
                    { id: 'adjective3', label: 'Adjective', placeholder: 'nervous, brave' },
                    { id: 'adjective4', label: 'Adjective', placeholder: 'massive, glowing' },
                    { id: 'animal', label: 'Sea Creature', placeholder: 'whale, sea serpent' },
                    { id: 'noun2', label: 'Noun', placeholder: 'telescope, rope' },
                    { id: 'verb1', label: 'Verb (Past Tense)', placeholder: 'ran, rushed' },
                    { id: 'adjective5', label: 'Adjective', placeholder: 'frightening, enormous' },
                    { id: 'adjective6', label: 'Adjective', placeholder: 'friendly, harmless' },
                    { id: 'adjective7', label: 'Adjective', placeholder: 'dark, furious' },
                    { id: 'direction', label: 'Direction', placeholder: 'north, west' },
                    { id: 'color1', label: 'Color', placeholder: 'black, grey' },
                    { id: 'color2', label: 'Color', placeholder: 'green, purple' },
                    { id: 'verb2', label: 'Verb (Base Form)', placeholder: 'sail, move' },
                    { id: 'verb3', label: 'Verb (Past Tense)', placeholder: 'sailed, rowed' },
                    { id: 'adverb1', label: 'Adverb', placeholder: 'bravely, swiftly' },
                    { id: 'adjective8', label: 'Adjective', placeholder: 'choppy, wild' },
                    { id: 'adjective9', label: 'Adjective', placeholder: 'beautiful, mysterious' },
                    { id: 'adjective10', label: 'Adjective', placeholder: 'lush, ancient' },
                    { id: 'noun3', label: 'Noun (Plural)', placeholder: 'trees, ruins' },
                    { id: 'exclamation2', label: 'Exclamation', placeholder: 'Incredible, Huzzah' },
                    { id: 'verb4', label: 'Verb (Past Tense)', placeholder: 'waded, swam' },
                    { id: 'adverb2', label: 'Adverb', placeholder: 'loudly, joyfully' }
                ]
            }
        ]
    },
    'creative-fill-in-2': {
        instructions: `Use the word shown in each input and change its form when needed. For blanks marked ?, enter any listed answer that fits.`,
        questions: [
            { id: 'q1', text: 'When the storm started, we quickly _____ all the windows.', correctAnswer: 'closed', placeholderHint: 'close' },
            { id: 'q2', text: 'Although the map was old, it still _____ us to the village.', correctAnswer: 'led', placeholderHint: 'lead' },
            { id: 'q3', text: 'By sunset, the hikers had _____ the mountain trail.', correctAnswer: 'finished', placeholderHint: 'finish' },
            { id: 'q4', text: 'The guide spoke _____ so everyone could hear the instructions.', correctAnswer: 'clearly', placeholderHint: 'clear' },
            { id: 'q5', text: 'After we crossed the bridge, we found a _____ cabin in the woods.', correctAnswer: 'small', placeholderHint: 'small' },
            { id: 'q6', text: 'Because the lantern was dim, we moved more _____.', correctAnswer: 'carefully', placeholderHint: 'careful' },
            { id: 'q7', text: 'At midnight, we heard a strange sound _____ the trees.', correctAnswers: ['among', 'between'] },
            { id: 'q8', text: 'In the end, the journey was difficult but very _____.', correctAnswer: 'rewarding', placeholderHint: 'reward' }
        ]
    },
    'creative-fill-in-3': {
        instructions: `Use the word shown in each input and change its form when needed. For blanks marked ?, enter any listed answer that fits.`,
        questions: [
            { id: 'q1', text: 'Had the team not reviewed the data twice, the error might have gone _____.', correctAnswers: ['unnoticed', 'undetected', 'unseen', 'uncorrected', 'unreported', 'unflagged'] },
            { id: 'q2', text: 'The curator, _____ had studied the archive for years, recognized the document immediately.', correctAnswer: 'who' },
            { id: 'q3', text: 'No sooner had the lights dimmed _____ the audience fell silent.', correctAnswer: 'than' },
            { id: 'q4', text: 'The proposal was persuasive; _____, it lacked a realistic budget.', correctAnswers: ['however', 'nevertheless', 'nonetheless', 'yet', 'still'] },
            { id: 'q5', text: 'By the time we arrived, the keynote speaker _____ the main argument.', correctAnswer: 'had outlined', placeholderHint: 'outline' },
            { id: 'q6', text: 'The committee recommended that each department _____ its own contingency plan.', correctAnswers: ['prepare', 'should prepare'], placeholderHint: 'prepare' },
            { id: 'q7', text: 'Only after the pilot phase ended _____ we understand the full scope of the challenge.', correctAnswer: 'did' },
            { id: 'q8', text: 'What made the narrative compelling was not only its structure but also its emotional _____.', correctAnswer: 'depth', placeholderHint: 'deep' },
            { id: 'q9', text: 'If the final draft had been clearer, stakeholders _____ fewer follow-up questions.', correctAnswers: ['would have asked', 'might have asked', 'could have asked'], placeholderHint: 'ask' },
            { id: 'q10', text: 'Despite tight deadlines, the team delivered a report that was both concise and _____.', correctAnswer: 'insightful', placeholderHint: 'insight' }
        ]
    },
    'sentence-revision-choice': {
        instructions: `Choose the best revised sentence.`,
        questions: [
            {
                id: 'q1',
                text: 'Choose the best revision: "She don\'t like the movie because it was boring."',
                options: [
                    'She doesn\'t like the movie because it was boring.',
                    'She don\'t like the movie because it was boring.',
                    'She doesn\'t likes the movie because it was boring.',
                    'She don\'t likes the movie because it was boring.'
                ],
                correctAnswer: 'She doesn\'t like the movie because it was boring.'
            },
            {
                id: 'q2',
                text: 'Choose the best revision: "Running down the street, the rain soaked Maya."',
                options: [
                    'Running down the street, Maya was soaked by the rain.',
                    'The rain soaked Maya, running down the street.',
                    'Running down the street, the rain soaked Maya.',
                    'Maya, running down the street, the rain soaked.'
                ],
                correctAnswer: 'Running down the street, Maya was soaked by the rain.'
            },
            {
                id: 'q3',
                text: 'Choose the clearest concise revision: "The dog was very happy due to the fact that it got a bone."',
                options: [
                    'The dog was happy to get a bone.',
                    'The dog was very happy due to the fact that it got a bone.',
                    'The dog was happy because it got the bone.',
                    'The dog was very, very happy since it got a bone.'
                ],
                correctAnswer: 'The dog was happy to get a bone.'
            },
            {
                id: 'q4',
                text: 'Choose the best revision: "He went to the store, he bought milk."',
                options: [
                    'He went to the store and bought milk.',
                    'He went to the store, he bought milk.',
                    'He went to the store; he bought milk,',
                    'He went to the store, and he had bought milk.'
                ],
                correctAnswer: 'He went to the store and bought milk.'
            },
            {
                id: 'q5',
                text: 'Choose the best revision: "There is many reasons to read every day."',
                options: [
                    'There are many reasons to read every day.',
                    'There is many reasons to read every day.',
                    'There are many reason to read every day.',
                    'There is many reason to read every day.'
                ],
                correctAnswer: 'There are many reasons to read every day.'
            }
        ]
    },
    'sentence-revision-intermediate': {
        instructions: `Choose the best revision for grammar and clarity.`,
        questions: [
            { id: 'q1', text: 'Choose the best revision: "The meeting was canceled, because nobody didn\'t prepare."', options: ['The meeting was canceled because nobody prepared.', 'The meeting was canceled, because nobody didn\'t prepare.', 'The meeting canceled because nobody not prepared.', 'The meeting was canceled because nobody was prepare.'], correctAnswer: 'The meeting was canceled because nobody prepared.' },
            { id: 'q2', text: 'Choose the best revision: "After reviewing the data, the conclusion was obvious to the team."', options: ['After reviewing the data, the team found the conclusion obvious.', 'After reviewing the data, the conclusion was obvious to the team.', 'After the team review data, the conclusion obvious.', 'Reviewing the data, obvious conclusion to the team.'], correctAnswer: 'After reviewing the data, the team found the conclusion obvious.' },
            { id: 'q3', text: 'Choose the clearest concise revision: "She explained the process clearly, and then she gave examples to explain it."', options: ['She explained the process clearly and then gave examples.', 'She explained the process clearly, and then she gave examples to explain it.', 'She explain the process clearly and then gave examples.', 'Clearly she explained, and then examples gave.'], correctAnswer: 'She explained the process clearly and then gave examples.' },
            { id: 'q4', text: 'Choose the best revision: "The new policy affects students differently, some benefit immediately."', options: ['The new policy affects students differently; some benefit immediately.', 'The new policy affects students differently, some benefit immediately.', 'The new policy affect students differently some benefit immediately.', 'The policy, students different, some immediate benefit.'], correctAnswer: 'The new policy affects students differently; some benefit immediately.' },
            { id: 'q5', text: 'Choose the best revision: "The device is more efficient than before, it use less power."', options: ['The device is more efficient than before and uses less power.', 'The device is more efficient than before, it use less power.', 'The device more efficient than before, and use less power.', 'The device is efficient before and less power uses.'], correctAnswer: 'The device is more efficient than before and uses less power.' },
            { id: 'q6', text: 'Choose the best revision: "Because the weather improved. The event started on time."', options: ['Because the weather improved, the event started on time.', 'Because the weather improved. The event started on time.', 'Because the weather improved, and the event started on time.', 'The weather improved because. The event on time started.'], correctAnswer: 'Because the weather improved, the event started on time.' }
        ]
    },
    'punctuation-practice': {
        instructions: `Select the sentence with correct punctuation.`,
        questions: [
            {
                id: 'q1',
                text: 'Which sentence is punctuated correctly?',
                options: [
                    'Its raining today.',
                    'It\'s raining today.',
                    'Its\' raining today.',
                    'It is raining today'
                ],
                correctAnswer: 'It\'s raining today.'
            },
            {
                id: 'q2',
                text: 'Which sentence is punctuated correctly?',
                options: [
                    'We bought apples bananas and oranges.',
                    'We bought apples, bananas, and oranges.',
                    'We bought apples, bananas and, oranges.',
                    'We bought apples; bananas; and oranges.'
                ],
                correctAnswer: 'We bought apples, bananas, and oranges.'
            },
            {
                id: 'q3',
                text: 'Which sentence is punctuated correctly?',
                options: [
                    'She said, "Let\'s go".',
                    'She said "Let\'s go."',
                    'She said, "Let\'s go."',
                    'She said; "Let\'s go."'
                ],
                correctAnswer: 'She said, "Let\'s go."'
            },
            {
                id: 'q4',
                text: 'Which sentence is punctuated correctly?',
                options: [
                    'Did you finish your homework.',
                    'Did you finish your homework?',
                    'Did you finish your homework!',
                    'Did you finish your homework,'
                ],
                correctAnswer: 'Did you finish your homework?'
            },
            {
                id: 'q5',
                text: 'Which sentence is punctuated correctly?',
                options: [
                    'The teachers desk was near the window.',
                    'The teacher\'s desk was near the window.',
                    'The teachers\'s desk was near the window.',
                    'The teacher desk was near the window.'
                ],
                correctAnswer: 'The teacher\'s desk was near the window.'
            }
        ]
    },
    'punctuation-intermediate': {
        instructions: `Select the sentence with correct punctuation.`,
        questions: [
            { id: 'q1', text: 'Which sentence is punctuated correctly?', options: ['After lunch we reviewed the draft, and submitted it.', 'After lunch, we reviewed the draft and submitted it.', 'After lunch, we reviewed, the draft and submitted it.', 'After lunch we reviewed the draft and, submitted it.'], correctAnswer: 'After lunch, we reviewed the draft and submitted it.' },
            { id: 'q2', text: 'Which sentence is punctuated correctly?', options: ['The manager said "Please update the timeline by Friday."', 'The manager said, "Please update the timeline by Friday."', 'The manager said, "Please update the timeline by Friday".', 'The manager said "Please update the timeline by Friday".'], correctAnswer: 'The manager said, "Please update the timeline by Friday."' },
            { id: 'q3', text: 'Which sentence is punctuated correctly?', options: ['My brother, who lives in Oslo is visiting this week.', 'My brother who lives in Oslo, is visiting this week.', 'My brother, who lives in Oslo, is visiting this week.', 'My brother who lives, in Oslo is visiting this week.'], correctAnswer: 'My brother, who lives in Oslo, is visiting this week.' },
            { id: 'q4', text: 'Which sentence is punctuated correctly?', options: ['We could take the train; however, tickets are expensive.', 'We could take the train, however; tickets are expensive.', 'We could take the train however, tickets are expensive.', 'We could take the train; however tickets are expensive'], correctAnswer: 'We could take the train; however, tickets are expensive.' },
            { id: 'q5', text: 'Which sentence is punctuated correctly?', options: ['Its clear that the data needs rechecking.', 'It\'s clear that the data needs rechecking.', 'Its\' clear that the data needs rechecking.', 'It\'s clear that the data, needs rechecking.'], correctAnswer: 'It\'s clear that the data needs rechecking.' },
            { id: 'q6', text: 'Which sentence is punctuated correctly?', options: ['The report covered cost quality and schedule.', 'The report covered cost, quality, and schedule.', 'The report covered, cost quality, and schedule.', 'The report covered cost; quality; and schedule.'], correctAnswer: 'The report covered cost, quality, and schedule.' }
        ]
    },
    'punctuation-advanced': {
        instructions: `Select the sentence with the best advanced punctuation.`,
        questions: [
            { id: 'q1', text: 'Which sentence is punctuated correctly?', options: ['Only one option remained namely, delaying the launch.', 'Only one option remained: delaying the launch.', 'Only one option remained; namely delaying the launch.', 'Only one option remained, delaying: the launch.'], correctAnswer: 'Only one option remained: delaying the launch.' },
            { id: 'q2', text: 'Which sentence is punctuated correctly?', options: ['The proposal while innovative, requires clearer cost estimates.', 'The proposal, while innovative, requires clearer cost estimates.', 'The proposal while innovative requires, clearer cost estimates.', 'The proposal, while innovative requires clearer, cost estimates.'], correctAnswer: 'The proposal, while innovative, requires clearer cost estimates.' },
            { id: 'q3', text: 'Which sentence is punctuated correctly?', options: ['Three teams applied; only one met all the criteria.', 'Three teams applied, only one met all the criteria.', 'Three teams applied only one met all the criteria.', 'Three teams applied: only, one met all the criteria.'], correctAnswer: 'Three teams applied; only one met all the criteria.' },
            { id: 'q4', text: 'Which sentence is punctuated correctly?', options: ['The analyst noted, "Results improved in Q3, but variance remained high."', 'The analyst noted "Results improved in Q3, but variance remained high."', 'The analyst noted, "Results improved in Q3, but variance remained high".', 'The analyst noted; "Results improved in Q3, but variance remained high."'], correctAnswer: 'The analyst noted, "Results improved in Q3, but variance remained high."' },
            { id: 'q5', text: 'Which sentence is punctuated correctly?', options: ['Students who completed all modules, performed significantly better.', 'Students who completed all modules performed significantly better.', 'Students, who completed all modules performed significantly better.', 'Students who completed all modules performed, significantly better.'], correctAnswer: 'Students who completed all modules performed significantly better.' },
            { id: 'q6', text: 'Which sentence is punctuated correctly?', options: ['The experiment failed for two reasons: inconsistent calibration and contaminated samples.', 'The experiment failed for two reasons, inconsistent calibration and contaminated samples.', 'The experiment failed: for two reasons, inconsistent calibration and contaminated samples.', 'The experiment failed for two reasons; inconsistent calibration, and contaminated samples.'], correctAnswer: 'The experiment failed for two reasons: inconsistent calibration and contaminated samples.' },
            { id: 'q7', text: 'Which sentence is punctuated correctly?', options: ['The interns prepared slides, the lead edited the final deck.', 'The interns prepared slides; the lead edited the final deck.', 'The interns prepared slides the lead edited the final deck.', 'The interns prepared slides: the lead, edited the final deck.'], correctAnswer: 'The interns prepared slides; the lead edited the final deck.' },
            { id: 'q8', text: 'Which sentence is punctuated correctly?', options: ['Our objective is simple improve clarity and reduce risk.', 'Our objective is simple: improve clarity and reduce risk.', 'Our objective is simple; improve clarity and reduce risk.', 'Our objective is simple, improve clarity and reduce risk.'], correctAnswer: 'Our objective is simple: improve clarity and reduce risk.' },
            { id: 'q9', text: 'Which sentence is punctuated correctly?', options: ['The article "Language and Power" sparked a strong debate.', 'The article, "Language and Power," sparked a strong debate.', 'The article "Language and Power", sparked a strong debate.', 'The article; "Language and Power" sparked a strong debate.'], correctAnswer: 'The article "Language and Power" sparked a strong debate.' },
            { id: 'q10', text: 'Which sentence is punctuated correctly if I have only one colleague?', options: ['My colleague who joined last year now leads the analytics team.', 'My colleague, who joined last year, now leads the analytics team.', 'My colleague who joined last year, now leads the analytics team.', 'My colleague, who joined last year now leads the analytics team.'], correctAnswer: 'My colleague, who joined last year, now leads the analytics team.' }
        ]
    },
    'transition-basics-1': {
        instructions: `Pick the best basic transition word.`,
        questions: [
            { id: 'q1', text: 'I was hungry, _____ I made a sandwich.', options: ['so', 'but', 'because', 'although'], correctAnswer: 'so' },
            { id: 'q2', text: 'She was tired, _____ she finished her homework.', options: ['but', 'so', 'because', 'therefore'], correctAnswer: 'but' },
            { id: 'q3', text: '_____ we left, we checked the lights.', options: ['Before', 'Because', 'However', 'So'], correctAnswer: 'Before' },
            { id: 'q4', text: 'He practiced daily; _____, he improved quickly.', options: ['therefore', 'however', 'for example', 'instead'], correctAnswer: 'therefore' },
            { id: 'q5', text: 'I wanted tea, _____ my friend wanted coffee.', options: ['while', 'so', 'because', 'therefore'], correctAnswer: 'while' }
        ]
    },
    'word-choice-basics-1': {
        instructions: `Choose the best word to complete each sentence.`,
        questions: [
            { id: 'q1', text: 'The test was very _____ for beginners.', options: ['easy', 'easily', 'ease', 'eased'], correctAnswer: 'easy' },
            { id: 'q2', text: 'Please speak more _____.', options: ['slowly', 'slow', 'slowness', 'slowed'], correctAnswer: 'slowly' },
            { id: 'q3', text: 'We need a _____ plan for tomorrow.', options: ['clear', 'clearly', 'clarity', 'clarify'], correctAnswer: 'clear' },
            { id: 'q4', text: 'She gave a very _____ answer.', options: ['helpful', 'helpfully', 'help', 'helper'], correctAnswer: 'helpful' },
            { id: 'q5', text: 'The child ran _____ to the door.', options: ['quickly', 'quick', 'quicker', 'quickness'], correctAnswer: 'quickly' }
        ]
    },
    'evidence-basics-1': {
        instructions: `Select all options that directly support the claim.`,
        questions: [
            {
                id: 'q1',
                text: 'Claim: Drinking water helps concentration.',
                options: [
                    'Students who drank water during class scored higher on attention tasks.',
                    'Water bottles come in many colors.',
                    'Hydrated learners reported less fatigue during long lessons.',
                    'Some students prefer juice.'
                ],
                correctAnswers: [
                    'Students who drank water during class scored higher on attention tasks.',
                    'Hydrated learners reported less fatigue during long lessons.'
                ],
                multiSelect: true
            },
            {
                id: 'q2',
                text: 'Claim: Reading daily improves language skills.',
                options: [
                    'Daily readers encounter new vocabulary in context.',
                    'Libraries often have comfortable chairs.',
                    'Regular reading improves comprehension over time.',
                    'Some books have colorful covers.'
                ],
                correctAnswers: [
                    'Daily readers encounter new vocabulary in context.',
                    'Regular reading improves comprehension over time.'
                ],
                multiSelect: true
            }
        ]
    },
    'transition-word-choice': {
        instructions: `Pick the best transition word or phrase.`,
        questions: [
            {
                id: 'q1',
                text: 'I was tired, ____ I finished my homework.',
                options: ['so', 'but', 'because', 'however'],
                correctAnswer: 'but'
            },
            {
                id: 'q2',
                text: 'It was raining; ____ we stayed inside.',
                options: ['therefore', 'for example', 'meanwhile', 'instead'],
                correctAnswer: 'therefore'
            },
            {
                id: 'q3',
                text: 'I wanted to go; ____ I had no money.',
                options: ['however', 'because', 'therefore', 'as a result'],
                correctAnswer: 'however'
            },
            {
                id: 'q4',
                text: 'He studied hard, ____ he passed the test.',
                options: ['so', 'yet', 'although', 'instead'],
                correctAnswer: 'so'
            },
            {
                id: 'q5',
                text: 'We packed snacks ____ we left early.',
                options: ['before', 'unless', 'although', 'while'],
                correctAnswer: 'before'
            }
        ]
    },
    'word-choice-clarity': {
        instructions: `Choose the word or phrase that makes the sentence most clear.`,
        questions: [
            {
                id: 'q1',
                text: 'The directions were ____ written.',
                options: ['clear', 'clearly', 'clearness', 'clarity'],
                correctAnswer: 'clearly'
            },
            {
                id: 'q2',
                text: 'The scientist ____ the reaction carefully.',
                options: ['observed', 'seen', 'observing', 'look'],
                correctAnswer: 'observed'
            },
            {
                id: 'q3',
                text: 'The book was ____ to read.',
                options: ['boring', 'boringly', 'bored', 'bore'],
                correctAnswer: 'boring'
            },
            {
                id: 'q4',
                text: 'We need to ____ the file is backed up.',
                options: ['ensure', 'insure', 'assure', 'secure'],
                correctAnswer: 'ensure'
            },
            {
                id: 'q5',
                text: 'He spoke in a ____ voice.',
                options: ['quiet', 'quietly', 'quietness', 'quieter'],
                correctAnswer: 'quiet'
            }
        ]
    },
    'transition-matching': {
        instructions: `Match each sentence to the best transition word or phrase.`,
        questions: [
            {
                id: 'q1',
                text: 'The bus was late; ____ we missed the movie.',
                options: ['therefore', 'for example', 'meanwhile', 'however'],
                correctAnswer: 'therefore'
            },
            {
                id: 'q2',
                text: 'I wanted to go; ____ I stayed home.',
                options: ['however', 'because', 'for example', 'in addition'],
                correctAnswer: 'however'
            },
            {
                id: 'q3',
                text: 'We packed snacks ____ we left early.',
                options: ['before', 'unless', 'although', 'while'],
                correctAnswer: 'before'
            },
            {
                id: 'q4',
                text: 'She loves sports; ____ she plays basketball and soccer.',
                options: ['for example', 'therefore', 'however', 'instead'],
                correctAnswer: 'for example'
            },
            {
                id: 'q5',
                text: 'He studied hard; ____ he passed.',
                options: ['as a result', 'meanwhile', 'however', 'for example'],
                correctAnswer: 'as a result'
            }
        ]
    },
    'sentence-ordering': {
        instructions: `Arrange the sentences to make a clear paragraph.`,
        ordering: {
            id: 'ordering',
            items: [
                { id: 's1', text: 'First, gather all of your ingredients on the counter.' },
                { id: 's2', text: 'Next, spread peanut butter on one slice of bread.' },
                { id: 's3', text: 'Then, spread jelly on the other slice of bread.' },
                { id: 's4', text: 'Finally, press the slices together and cut the sandwich.' }
            ],
            correctOrder: ['s1', 's2', 's3', 's4']
        }
    },
    'evidence-multi-select': {
        instructions: `Select all sentences that support the claim.`,
        questions: [
            {
                id: 'q1',
                text: 'Claim: School uniforms improve focus.',
                options: [
                    'Uniforms reduce distractions from clothing choices.',
                    'Some students like fashion.',
                    'Students spend less time choosing outfits.',
                    'Uniforms are sold in many colors.'
                ],
                correctAnswers: [
                    'Uniforms reduce distractions from clothing choices.',
                    'Students spend less time choosing outfits.'
                ],
                multiSelect: true
            },
            {
                id: 'q2',
                text: 'Claim: Reading daily builds vocabulary.',
                options: [
                    'Books include many new words.',
                    'Some books have pictures.',
                    'Reading exposes readers to varied language.',
                    'Libraries are quiet places.'
                ],
                correctAnswers: [
                    'Books include many new words.',
                    'Reading exposes readers to varied language.'
                ],
                multiSelect: true
            }
        ]
    },
    'evidence-extended-arguments': {
        instructions: `Read each claim carefully. Select all options that provide direct, relevant evidence. Ignore opinions, unrelated facts, and vague statements.`,
        questions: [
            {
                id: 'q1',
                text: 'Claim: A later school start time improves student learning outcomes in secondary schools.',
                options: [
                    'A district that shifted its start time from 7:20 to 8:30 reported a 12% increase in first-period attendance within one semester.',
                    'Many students say early mornings feel stressful and unpleasant.',
                    'Teachers in the same district reported fewer students falling asleep in first-period classes after the schedule change.',
                    'One principal prefers later schedules because traffic near the campus is lighter.',
                    'A two-year comparison showed average math scores rising by 8 points after start times were delayed, while curriculum and staffing remained stable.'
                ],
                correctAnswers: [
                    'A district that shifted its start time from 7:20 to 8:30 reported a 12% increase in first-period attendance within one semester.',
                    'Teachers in the same district reported fewer students falling asleep in first-period classes after the schedule change.',
                    'A two-year comparison showed average math scores rising by 8 points after start times were delayed, while curriculum and staffing remained stable.'
                ],
                multiSelect: true
            },
            {
                id: 'q2',
                text: 'Claim: Cities should expand protected bike-lane networks to reduce commuter car use.',
                options: [
                    'After 18 km of protected lanes were installed, weekday bike commuting increased from 9% to 17% in the corridor.',
                    'Some drivers believe bike lanes make streets look crowded.',
                    'A commuter survey found that 41% of new bike-lane users had previously driven to work at least four days per week.',
                    'The city received positive comments about the color of the lane separators.',
                    'Traffic counts showed a 14% decrease in single-occupancy vehicles on parallel routes during peak hours.'
                ],
                correctAnswers: [
                    'After 18 km of protected lanes were installed, weekday bike commuting increased from 9% to 17% in the corridor.',
                    'A commuter survey found that 41% of new bike-lane users had previously driven to work at least four days per week.',
                    'Traffic counts showed a 14% decrease in single-occupancy vehicles on parallel routes during peak hours.'
                ],
                multiSelect: true
            },
            {
                id: 'q3',
                text: 'Claim: Schools should provide structured study-skills workshops to improve academic performance.',
                options: [
                    'After a semester of weekly workshops, participating students improved average exam scores by 9% compared with non-participants.',
                    'Some students said the workshop handouts looked professional.',
                    'Attendance records showed that students who attended at least 80% of sessions submitted assignments on time 30% more often.',
                    'A teacher said workshops are "a nice extra" for motivated learners.',
                    'A matched-group analysis found lower course-failure rates in classes where study-skills workshops were embedded.'
                ],
                correctAnswers: [
                    'After a semester of weekly workshops, participating students improved average exam scores by 9% compared with non-participants.',
                    'Attendance records showed that students who attended at least 80% of sessions submitted assignments on time 30% more often.',
                    'A matched-group analysis found lower course-failure rates in classes where study-skills workshops were embedded.'
                ],
                multiSelect: true
            }
        ]
    },
    'evidence-academic-analysis': {
        instructions: `For each claim, choose every sentence that functions as strong academic evidence (data, controlled comparisons, or source-based findings).`,
        questions: [
            {
                id: 'q1',
                text: 'Claim: Project-based learning (PBL) strengthens long-term retention of scientific concepts.',
                options: [
                    'In a controlled study of 640 students, the PBL group scored 15% higher on a delayed post-test administered eight weeks after instruction.',
                    'Several students described the projects as creative and enjoyable.',
                    'Both groups used the same textbook and assessment rubric, but only the PBL group completed collaborative design tasks.',
                    'A teacher said the classroom felt more energetic during project weeks.',
                    'Researchers reported that PBL students made fewer conceptual errors on transfer tasks requiring application to new scenarios.'
                ],
                correctAnswers: [
                    'In a controlled study of 640 students, the PBL group scored 15% higher on a delayed post-test administered eight weeks after instruction.',
                    'Both groups used the same textbook and assessment rubric, but only the PBL group completed collaborative design tasks.',
                    'Researchers reported that PBL students made fewer conceptual errors on transfer tasks requiring application to new scenarios.'
                ],
                multiSelect: true
            },
            {
                id: 'q2',
                text: 'Claim: Public libraries that provide structured digital-literacy programs improve employment outcomes for adult learners.',
                options: [
                    'Among program participants, 38% obtained interviews within three months, compared with 22% in a matched non-participant group.',
                    'Several participants said they appreciated the friendliness of library staff.',
                    'Workshop attendance records showed that learners who completed all six sessions were twice as likely to submit online applications weekly.',
                    'One city council member argued that libraries should focus only on books.',
                    'A follow-up survey found statistically significant gains in resume quality scores before and after the program.'
                ],
                correctAnswers: [
                    'Among program participants, 38% obtained interviews within three months, compared with 22% in a matched non-participant group.',
                    'Workshop attendance records showed that learners who completed all six sessions were twice as likely to submit online applications weekly.',
                    'A follow-up survey found statistically significant gains in resume quality scores before and after the program.'
                ],
                multiSelect: true
            },
            {
                id: 'q3',
                text: 'Claim: Integrating weekly low-stakes quizzes improves long-term retention in introductory science courses.',
                options: [
                    'Across four cohorts, students in quiz-integrated sections scored significantly higher on cumulative final exam items aligned to earlier units.',
                    'Several students said they preferred short quizzes to long exams.',
                    'Instructors used the same textbook, lecture slides, and lab activities; the quiz condition differed only by weekly retrieval practice.',
                    'One department chair noted that quizzes are easy to grade online.',
                    'A delayed retention test six weeks later showed lower forgetting rates in the quiz-integrated group.'
                ],
                correctAnswers: [
                    'Across four cohorts, students in quiz-integrated sections scored significantly higher on cumulative final exam items aligned to earlier units.',
                    'Instructors used the same textbook, lecture slides, and lab activities; the quiz condition differed only by weekly retrieval practice.',
                    'A delayed retention test six weeks later showed lower forgetting rates in the quiz-integrated group.'
                ],
                multiSelect: true
            }
        ]
    },
    'drag-drop-structure': {
        instructions: `Drag each sentence into the correct part of the paragraph.`,
        dragDrop: {
            id: 'drag-drop-structure',
            items: [
                { id: 'i1', text: 'Recycling helps keep our neighborhoods clean.' },
                { id: 'i2', text: 'It reduces the trash sent to landfills.' },
                { id: 'i3', text: 'Recycling also saves energy used to make new products.' },
                { id: 'i4', text: 'For these reasons, everyone should recycle.' }
            ],
            zones: [
                { id: 'topic', label: 'Topic Sentence' },
                { id: 'detail', label: 'Supporting Detail' },
                { id: 'conclusion', label: 'Conclusion' }
            ],
            correctMapping: {
                topic: ['i1'],
                detail: ['i2', 'i3'],
                conclusion: ['i4']
            }
        }
    },
    'sentence-revision-advanced': {
        instructions: `Choose the best revision for clarity, concision, and grammatical accuracy.`,
        questions: [
            {
                id: 'q1',
                text: 'Choose the best revision: "The committee members, they decided to postpone the vote until next week."',
                options: [
                    'The committee members decided to postpone the vote until next week.',
                    'The committee members, they decided to postpone the vote until next week.',
                    'The committee members they decided, to postpone the vote until next week.',
                    'Decided by the committee members, the vote was postponed by them until next week.'
                ],
                correctAnswer: 'The committee members decided to postpone the vote until next week.'
            },
            {
                id: 'q2',
                text: 'Choose the best revision: "Although the weather was bad. We continued the field study."',
                options: [
                    'Although the weather was bad, we continued the field study.',
                    'Although the weather was bad. We continued the field study.',
                    'Although the weather was bad, and we continued the field study.',
                    'The weather was bad although, we continued the field study.'
                ],
                correctAnswer: 'Although the weather was bad, we continued the field study.'
            },
            {
                id: 'q3',
                text: 'Choose the best revision: "The report is long, it is still easy to follow."',
                options: [
                    'The report is long, it is still easy to follow.',
                    'The report is long; however, it is still easy to follow.',
                    'The report is long however it is still easy to follow.',
                    'The report long is still easy to follow.'
                ],
                correctAnswer: 'The report is long; however, it is still easy to follow.'
            },
            {
                id: 'q4',
                text: 'Choose the best revision: "Each students must submit their draft by Friday."',
                options: [
                    'Each students must submit their draft by Friday.',
                    'Each student must submit their draft by Friday.',
                    'Each student must submits their draft by Friday.',
                    'Each student must submit they draft by Friday.'
                ],
                correctAnswer: 'Each student must submit their draft by Friday.'
            },
            {
                id: 'q5',
                text: 'Choose the best revision: "Being late for the interview, the opportunity was missed by Carla."',
                options: [
                    'Being late for the interview, the opportunity was missed by Carla.',
                    'Carla was late for the interview and missed the opportunity.',
                    'Late for the interview, the opportunity missed Carla.',
                    'The opportunity being late was missed by Carla for the interview.'
                ],
                correctAnswer: 'Carla was late for the interview and missed the opportunity.'
            },
            {
                id: 'q6',
                text: 'Choose the best revision: "The data was collected, analyzed, and then the team wrote the conclusion."',
                options: [
                    'The data was collected, analyzed, and then the team wrote the conclusion.',
                    'The data was collected and analyzed, and then the team wrote the conclusion.',
                    'Collected data analyzed and then the team wrote conclusion.',
                    'The data, and analyzed, then the team wrote the conclusion.'
                ],
                correctAnswer: 'The data was collected and analyzed, and then the team wrote the conclusion.'
            },
            {
                id: 'q7',
                text: 'Choose the best revision: "The software update improved speed. Also reducing memory use."',
                options: [
                    'The software update improved speed. Also reducing memory use.',
                    'The software update improved speed, also reducing memory use.',
                    'The software update improved speed and also reduced memory use.',
                    'Improved speed and reducing memory use was the software update.'
                ],
                correctAnswer: 'The software update improved speed and also reduced memory use.'
            },
            {
                id: 'q8',
                text: 'Choose the best revision: "There are less errors in the second version than the first."',
                options: [
                    'There are less errors in the second version than the first.',
                    'There are fewer errors in the second version than in the first.',
                    'There is fewer errors in the second version than first.',
                    'There are fewer error in the second version than in first.'
                ],
                correctAnswer: 'There are fewer errors in the second version than in the first.'
            },
            {
                id: 'q9',
                text: 'Choose the best revision: "The manager explained the policy to the interns clear and patiently."',
                options: [
                    'The manager explained the policy to the interns clear and patiently.',
                    'The manager explained the policy to the interns with clarity and patience.',
                    'The manager explained clearly to interns the policy with patiently.',
                    'The policy to the interns was explained clearly and patient by the manager.'
                ],
                correctAnswer: 'The manager explained the policy to the interns with clarity and patience.'
            },
            {
                id: 'q10',
                text: 'Choose the best revision: "Because the sample size was small, therefore the results should be interpreted cautiously."',
                options: [
                    'Because the sample size was small, therefore the results should be interpreted cautiously.',
                    'Because the sample size was small, the results should be interpreted cautiously.',
                    'The sample size was small, therefore because the results should be interpreted cautiously.',
                    'Because the sample size small, the results should cautious be interpreted.'
                ],
                correctAnswer: 'Because the sample size was small, the results should be interpreted cautiously.'
            }
        ]
    },
    'word-choice-advanced': {
        instructions: `Choose the most precise and context-appropriate word or phrase.`,
        questions: [
            { id: 'q1', text: 'The researcher supported every step with reproducible evidence, presenting a _____ explanation of the anomaly.', options: ['plausible', 'rigorous', 'casual', 'tentative'], correctAnswer: 'rigorous' },
            { id: 'q2', text: 'The board requested a _____ timeline with exact dates and measurable milestones.', options: ['specific', 'realistic', 'flexible', 'provisional'], correctAnswer: 'specific' },
            { id: 'q3', text: 'To avoid bias, the sample must be _____ selected.', options: ['randomly', 'random', 'randomness', 'randomize'], correctAnswer: 'randomly' },
            { id: 'q4', text: 'The summary should be concise but still _____.', options: ['comprehensive', 'lengthy', 'wordy', 'repetitive'], correctAnswer: 'comprehensive' },
            { id: 'q5', text: 'Her feedback was direct without being _____.', options: ['hostile', 'helpful', 'constructive', 'balanced'], correctAnswer: 'hostile' },
            { id: 'q6', text: 'The policy language is too technical for a _____ audience.', options: ['general', 'specialized', 'professional', 'academic'], correctAnswer: 'general' },
            { id: 'q7', text: 'The proposal lacks evidence strong enough to support causation; it lacks _____ evidence.', options: ['anecdotal', 'sufficient', 'dramatic', 'interesting'], correctAnswer: 'sufficient' },
            { id: 'q8', text: 'Use a neutral tone when writing _____ updates to external partners and sponsors.', options: ['stakeholder', 'internal', 'casual', 'promotional'], correctAnswer: 'stakeholder' },
            { id: 'q9', text: 'The conclusion should _____ the main claim, not introduce new points.', options: ['reinforce', 'divert', 'confuse', 'hide'], correctAnswer: 'reinforce' },
            { id: 'q10', text: 'To follow scholarly writing conventions in a university essay, use a more _____ register.', options: ['academic', 'casual', 'personal', 'colloquial'], correctAnswer: 'academic' }
        ]
    },
    'transition-advanced-usage': {
        instructions: `Choose the transition that best matches the logical relationship.`,
        questions: [
            { id: 'q1', text: 'The pilot sample was small; _____, the findings should be treated as preliminary.', options: ['therefore', 'for example', 'meanwhile', 'likewise'], correctAnswer: 'therefore' },
            { id: 'q2', text: 'The policy reduced costs. _____, service quality remained stable.', options: ['Moreover', 'However', 'For instance', 'Instead'], correctAnswer: 'Moreover' },
            { id: 'q3', text: 'The timeline appears feasible; _____, several dependencies are still unresolved.', options: ['consequently', 'however', 'similarly', 'in addition'], correctAnswer: 'however' },
            { id: 'q4', text: 'The team met every milestone. _____, the final delivery was delayed by vendor issues.', options: ['Nevertheless', 'For example', 'Likewise', 'As a result'], correctAnswer: 'Nevertheless' },
            { id: 'q5', text: 'User complaints declined by 30%; _____, satisfaction scores increased.', options: ['correspondingly', 'instead', 'otherwise', 'although'], correctAnswer: 'correspondingly' },
            { id: 'q6', text: 'We can postpone the launch, or _____ we can reduce scope and ship on time.', options: ['alternatively', 'therefore', 'indeed', 'meanwhile'], correctAnswer: 'alternatively' },
            { id: 'q7', text: 'The model performed well on internal data. _____, external validation is still required.', options: ['That said', 'For example', 'Similarly', 'As a result'], correctAnswer: 'That said' },
            { id: 'q8', text: 'The claim sounds plausible; _____, current evidence is inconclusive.', options: ['nonetheless', 'therefore', 'specifically', 'namely'], correctAnswer: 'nonetheless' },
            { id: 'q9', text: 'Several low-cost options exist. _____, Option B has the strongest reliability record.', options: ['Among them', 'On the contrary', 'Besides', 'Nevertheless'], correctAnswer: 'Among them' },
            { id: 'q10', text: 'The interface is simpler now; _____, training time has dropped significantly.', options: ['as a result', 'for instance', 'otherwise', 'in contrast'], correctAnswer: 'as a result' }
        ]
    },
    'paragraph-organization-2': {
        instructions: `Arrange the sentences to form a coherent paragraph.`,
        ordering: {
            id: 'paragraph-organization-2',
            items: [
                { id: 's1', text: 'Many schools are adding short movement breaks during long lessons.' },
                { id: 's2', text: 'These breaks help students reset attention and reduce restlessness.' },
                { id: 's3', text: 'Beyond that immediate reset, teachers report better participation after students stand, stretch, or walk briefly.' },
                { id: 's4', text: 'For this reason, structured movement can improve classroom learning conditions.' },
                { id: 's5', text: 'For example, even a two-minute break can make the next activity more productive.' }
            ],
            correctOrder: ['s1', 's2', 's5', 's3', 's4']
        }
    },
    'paragraph-organization-3': {
        instructions: `Arrange the paragraph components to build a clear academic argument.`,
        ordering: {
            id: 'paragraph-organization-3',
            items: [
                { id: 's1', text: 'Public transit investment should be prioritized in rapidly growing cities.' },
                { id: 's2', text: 'When bus and rail networks expand, commute times become more predictable for workers.' },
                { id: 's3', text: 'In one regional study, households near frequent transit lines spent less on transportation overall.' },
                { id: 's4', text: 'Critics argue that expansion projects are expensive and disruptive during construction.' },
                { id: 's5', text: 'However, phased construction and transparent budgeting can reduce short-term disruption while preserving long-term gains.' },
                { id: 's6', text: 'Therefore, cities that plan for growth should treat reliable transit as essential infrastructure rather than optional spending.' }
            ],
            correctOrder: ['s1', 's2', 's3', 's4', 's5', 's6']
        }
    }
};
